export default {
  manage: {
    en: "MANAGE",
    ja: "管理"
  }
}
